import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=28dcbf70&scoped=true&"
import script from "./SignUpForm.vue?vue&type=script&lang=ts&"
export * from "./SignUpForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=28dcbf70&lang=scss&"
import style1 from "./SignUpForm.vue?vue&type=style&index=1&id=28dcbf70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcbf70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dcbf70')) {
      api.createRecord('28dcbf70', component.options)
    } else {
      api.reload('28dcbf70', component.options)
    }
    module.hot.accept("./SignUpForm.vue?vue&type=template&id=28dcbf70&scoped=true&", function () {
      api.rerender('28dcbf70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/components/SignUpForm.vue"
export default component.exports